import { FlipCard, Side } from './FlipCard';
FlipCard.Side = Side;
export default FlipCard;
